
import { Injectable } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { Storage } from '@ionic/storage-angular';
import { UserConfigDto } from 'src/providersdata/UserConfigDto';
import { APIService } from '../apiservices/apiservices';
import { UserRoot } from './UsuarioLogado';
@Injectable()
export class LocalStorageProvider {
  private header = APIService.getHeader();
  private userConfig: UserConfigDto = null;

  constructor(
    public router: Router,
    public storage: Storage
  ) {
    
    this.initDefaultsStorage();
  }

  private initDefaultsStorage() {
    this.storage.create();
  }

  public get loggedUser(): { Usuario: UserRoot; Config: UserConfigDto } {
    try {

      if(APIService.UsuarioLogado?.Usuario) 
      {
        let login1 = APIService.UsuarioLogado.Usuario.login1;
        let config = this.getUserConfig(login1);

        return {
          Usuario: APIService.UsuarioLogado.Usuario,
          Config: config,
        };
      }

      var usuario = APIService.UsuarioLogado.Usuario;

      let usuarioLogadoData = localStorage.getItem(`${APIService.storage_key}usuario`);

      if (usuarioLogadoData) {
        let usuarioLogado = JSON.parse(usuarioLogadoData) as UserRoot;

        APIService.UsuarioLogado.Usuario = usuarioLogado;

        usuario = usuarioLogado;
      }
      
      var config = new UserConfigDto(null);

      if (usuario) {
        config = this.getUserConfig(usuario.login1);
      }

      return {
        Usuario: usuario,
        Config: config,
      };
    } catch (error) {
        return {
            Usuario: null,
            Config: null,
        };
    }
  }

  public set loggedUser(value: Partial<UserRoot>) {
    if (!value) return;

    APIService.UsuarioLogado.Usuario = value as UserRoot;

    localStorage.setItem(`${APIService.storage_key}usuario`, JSON.stringify(value));

    let storageUserConfig = localStorage.getItem('uc' + APIService.storage_key + value.login1);

    if (storageUserConfig) {
      let userConfig = JSON.parse(storageUserConfig) as UserConfigDto;

      APIService.UsuarioLogado.dataToken = value.dataToken;

      APIService.UsuarioLogado.TOKENJWT = value.token;
    }
  }

  get user(): UserConfigDto {
    if (this.userConfig == null) {
      var usu = APIService.UsuarioLogado.Usuario;
      this.userConfig = this.getUserConfig(usu.login1);

      return this.userConfig;
    } else {
      return new UserConfigDto(this.userConfig);
    }
  }

  public logout(): void {
    let usuario = APIService.UsuarioLogado.Usuario;

    if (!usuario) {
      let usuarioLogadoData = localStorage.getItem(`${APIService.storage_key}usuario`);

      if (usuarioLogadoData) {
        let usuarioLogado = JSON.parse(usuarioLogadoData) as UserRoot;

        usuario = usuarioLogado;
      }
    }

    if (usuario) {
      // localStorage.removeItem('uc' + usuario.login1);
    }

    // localStorage.removeItem('usuario');

    if (this.router.url != '/login') 
      this.router.navigateByUrl('/login');
    

  }

  public async getUser(usuario: string = 'usuario')
  {
    return await this.storage.get(APIService.storage_key + usuario);
  }

  public async setUser(usuario: string = 'usuario', data: any)
  {
    return await this.storage.set(APIService.storage_key + usuario, data);
  }

  public getUserConfig(usuario: string = ''): UserConfigDto {
    // this.storage.get(APIService.storage_key + usuario).then(ex => {
    //   // //console.log('StorageUser', ex)
    // })

    if (!usuario) {
      const usuarioLogado = this.loggedUser;

      if (
        usuarioLogado.Usuario &&
        usuarioLogado.Config.usuario == usuarioLogado.Usuario.login1
      ) {
        return usuarioLogado.Config;
      }
    }

    let obj: any = JSON.parse(localStorage.getItem('uc' + APIService.storage_key + usuario));

    if (obj?.dataToken) {
      let dataToken: Date = new Date(obj.dataToken);
      let now = new Date();
      if (dataToken < now) {
        this.router.events.subscribe((event: RouterEvent) => {
          //console.log (event?.url);
          if (event instanceof NavigationEnd && event?.url?.includes('/password')==false) {
            // varificando se deu alguma problema na leitura, garantindo que o usuário não está logado
            let dataToken2: Date = new Date(APIService.UsuarioLogado?.dataToken);
            //alert (dataToken2);
            if (dataToken2 < now){
              this.router.navigate(['/login']);
              return null;
            }
            
          }
          // else{
          //   return null;
          // }
        });
         

        
      }
    }

    this.userConfig = obj;

    return new UserConfigDto(obj);
  }

  public saveUserConfig(config: UserConfigDto): void {
    // this.storage.store('uc' + config.usuario, config);
    //console.log(config)
    localStorage.setItem('uc' + APIService.storage_key + config.usuario, JSON.stringify(config));
  }

  public saveUserConfigAsync(config: UserConfigDto): Promise<void> {
    return new Promise((resolve) => {
      localStorage.setItem('uc' + APIService.storage_key + config.usuario, JSON.stringify(config));
      resolve();
    });
  }
  
  public login(usuario: string, data: Partial<UserConfigDto>): void {
    console.log(data);
    // var prevData = this.getUserConfig(usuario);

    // if (prevData?.usuario) {
    //   Object.keys(data).forEach((key) => {
    //     if (data[key]) {
    //       prevData[key] = data[key];
    //     }
    //   });
    //   prevData.dataToken=data.dataToken;
    //   prevData.token=data.token;
    //   this.saveUserConfig(prevData);
    // } else {
      data.usuario = usuario;
      let config = new UserConfigDto(data);
      this.saveUserConfig(config);
    // }
  }

  public loginAsync(usuario: string, data: Partial<UserConfigDto>): Promise<void> {
    return new Promise((resolve) => {
      data.usuario = usuario;
      let config = new UserConfigDto(data);
      this.saveUserConfigAsync(config).then(() => {
        resolve();
      });
    });
  }

  public getCookielgpd(): boolean {
    return localStorage.getItem('lgpd') == '1';
  }

  public setCookielgpd(): void {
    localStorage.setItem('lgpd', '1');
  }
}
